export const API = "https://mern-ecommerce-website.herokuapp.com/api";
